const isLast = (index, collection) => {
  return index === collection.length - 1;
}


export default isLast;
